// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var JwtStatus = function (x) {
    return x;
};
var tsBridgeJwtStatus = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("JwtStatus")("__brandJwtStatus"));
    }
};
var writeJwtStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showJwtStatus = Data_Show.showString;
var readJwtStatus = Simple_JSON.readString;
var ordJwtStatus = Data_Ord.ordString;
var newtypeJwtStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeJwtStatus = JwtStatus;
var eqJwtStatus = Data_Eq.eqString;
export {
    JwtStatus,
    makeJwtStatus,
    unwrap,
    newtypeJwtStatus,
    eqJwtStatus,
    ordJwtStatus,
    showJwtStatus,
    readJwtStatus,
    writeJwtStatus,
    tsBridgeJwtStatus
};
//# sourceMappingURL=index.js.map
